export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11060.a19b40b6.jpg";